import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onTrapLpcFocus = action('onTrapLpcFocus', event => ({
    event,
    owaType: 'trapLpcFocus',
})) as OwaNovaActionUnion<'trapLpcFocus'>;
